import {css} from "@panda/css";

import {PricesViewType} from "../../helpers/prices_view_type";
import {DistrictRow} from "../../types/DistrictRow";
import {PricesDistrictCard} from "./PricesDistrictCard";

interface Props {
    districts: DistrictRow[];
    citySlug: string;
    type: PricesViewType;
    yearAgoDateLabel?: string;
}

export const PricesDistrictsCarousel = (props: Props) => {
    const {districts, citySlug, type, yearAgoDateLabel} = props;

    return (
        <div className={carouselStyle}>
            {districts.map((district) => (
                <PricesDistrictCard key={district.id} district={district} citySlug={citySlug} type={type} yearAgoDateLabel={yearAgoDateLabel} />
            ))}
        </div>
    );
};

const carouselStyle = css({
    display: "flex",
    gap: 2,
    overflowX: "auto",

    md: {
        display: "none"
    }
});
import {css} from "@panda/css";

import {PricesViewType} from "../../helpers/prices_view_type";
import {DistrictRow} from "../../types/DistrictRow";
import {PricesDistrictCard} from "./PricesDistrictCard";

interface Props {
    districts: DistrictRow[];
    citySlug: string;
    type: PricesViewType;
    yearAgoDateLabel?: string;
}

export const PricesDistrictsCarousel = (props: Props) => {
    const {districts, citySlug, type, yearAgoDateLabel} = props;

    return (
        <div className={carouselStyle}>
            {districts.map((district) => (
                <PricesDistrictCard key={district.id} district={district} citySlug={citySlug} type={type} yearAgoDateLabel={yearAgoDateLabel} />
            ))}
        </div>
    );
};

const carouselStyle = css({
    display: "flex",
    gap: 2,
    overflowX: "auto",

    md: {
        display: "none"
    }
});
